function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViews = function SvgViews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 12.6 8.06",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M12.48,3.66C12.37,3.51,9.7,0,6.3,0S.41,3.28.12,3.66a.65.65,0,0,0,0,.75C.24,4.56,2.9,8.06,6.3,8.06s5.89-3.28,6.18-3.65A.65.65,0,0,0,12.48,3.66ZM11.16,4c-.72.82-2.67,2.78-4.86,2.78S2.17,4.85,1.44,4c.73-.82,2.67-2.77,4.86-2.77S10.44,3.21,11.16,4Z",
    style: {
      fill: "#bac1ce"
    }
  }), React.createElement("path", {
    d: "M4.16,4A2.14,2.14,0,1,0,6.3,1.89,2.14,2.14,0,0,0,4.16,4ZM5.42,4A.89.89,0,0,1,7.19,4,.89.89,0,1,1,5.42,4Z",
    style: {
      fill: "#bac1ce"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgViews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/views.101156b5.svg";
export { ForwardRef as ReactComponent };